'use strict';

var app = angular.module('limaApp', [
  'ngCookies',
  'ngResource',
  'ngSanitize',
  'btford.socket-io',
  'ui.router',
  'ui.router.state.events',
  'ui.bootstrap',
  'ngAnimate',
  'pascalprecht.translate',
  'ngTouch',
  //'ngDragDrop',
  'ui.sortable',

  'ngStorage',
  'isteven-multi-select',
  'smart-table'
   ,
   'angularFileUpload',
   'flow',
   require('angular-bootstrap-calendar'),
  'ngFileUpload'
  //  ,
  //  'angular-fullcalendar'
]);

app.config(['$stateProvider', '$urlRouterProvider', '$locationProvider', '$httpProvider', '$translateProvider', 'uibDatepickerConfig', 'uibDatepickerPopupConfig','flowFactoryProvider',
function ($stateProvider, $urlRouterProvider, $locationProvider, $httpProvider, $translateProvider, datepickerConfig, datepickerPopupConfig, flowFactoryProvider) {
  $urlRouterProvider.otherwise('/');
  $locationProvider.html5Mode(true);
  $httpProvider.interceptors.push('authInterceptor');

  //initialize get if not there
  if (!$httpProvider.defaults.headers.get) {
      $httpProvider.defaults.headers.get = {};
  }
  //disable IE ajax request caching
  $httpProvider.defaults.headers.get['If-Modified-Since'] = '0';
  $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
  $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';

  $translateProvider.useSanitizeValueStrategy('escapeParameters', 'sanitizeParameters');
  $translateProvider.useStaticFilesLoader({prefix: 'resources/i18n/locale-', suffix: '.json'});
  $translateProvider.preferredLanguage('ja');
  $translateProvider.fallbackLanguage('en');
  $translateProvider.useMissingTranslationHandlerLog();
/*
  $translateProvider.useLocalStorage(); // this will let the brower cache the string resource
*/

  datepickerConfig.showWeeks = false;
  if ($translateProvider.preferredLanguage() === 'ja') {
    datepickerConfig.formatDayTitle = 'yyyy年MMMM';
    datepickerPopupConfig.currentText = '今日';
    datepickerPopupConfig.clearText = '消去';
    datepickerPopupConfig.closeText = '閉じる';
    datepickerPopupConfig.altInputFormats = ['yyyy/M!/d!'];
  }
  flowFactoryProvider.defaults = {
    //target: 'http://192.168.103.110:9000/api/v1/file',
//    target: 'http://localhost:8061/api/v1/file',
    target: 'http://localhost:8060/api/v1/file',
    permanentErrors: [404, 500, 501],
    maxChunkRetries: 1,
    chunkRetryInterval: 5000,
    simultaneousUploads: 4
  };
  flowFactoryProvider.on('catchAll', function (event) {
    console.log('catchAll', arguments);
  });


}]);


app.factory('LimaRedirect', ['$location', '$timeout', '$cookies', '$injector',
function LimaRedirect($location, $timeout, $cookies, $injector) {
  return {
    go: function (options) {
      options = options || {};
      if (!options.path) return;
      if (typeof options.delay === 'number') return $timeout(function () { delete options.delay; this.go(options); }.bind(this), options.delay);
      if (options.returnPath === true) options.returnPath = $location.path();
      if (options.returnPath && options.returnPath !== options.path) this.returnPath = options.returnPath;
      this.help = options.help || '';
      $location.path(options.path || '/');
      if (options.history === false) $location.replace();
      if (options.clearCache === true) {
        // remove any stale tokens
        $cookies.remove('token', {path:'/', domain:$location.host()});
        try { $injector.get('socket').disconnect(); } catch (ex) {};
        try { $injector.get('Auth').systemProperties({clear:true}); } catch (ex) {};
      }
    },
    back: function (options) {
      options = options || {};
      var returnPath = this.returnPath || options.returnPath;
      delete this.returnPath;
      delete this.help;
      if (!returnPath) return;
      $location.path(returnPath);
      return returnPath;
    }
  };
}]);

app.factory('authInterceptor', ['$rootScope', '$q', '$cookies', 'LimaRedirect',
function ($rootScope, $q, $cookies, LimaRedirect) {
  return {
    // Add authorization token to headers
    request: function (config) {
      config.headers = config.headers || {};
      if ($cookies.get('token')) {
        config.headers.Authorization = 'Bearer ' + $cookies.get('token');
      }
      return config;
    },

    // Intercept 401s and redirect you to login
    responseError: function(response) {
      if(response.status === 401) {
        LimaRedirect.go({path:'/login', returnPath:true, help:'Login session has expired', clearCache:true});
        return $q.reject(response);
      } else {
        return $q.reject(response);
      }
    }
  };
}]);

app.directive('updateTitle', ['$state', 'Auth',
function ($state, Auth) {
  return {
    restrict: 'A',
    link: function (scope, element) {
      scope.$on('$stateChangeSuccess', function () {
        element.html($state.current.title);
      });
    }
  };
}]);

app.run(['$rootScope','$http', '$location', '$urlRouter', '$translate', '$q', '$cookies', 'Auth', 'LimaRedirect', 'LimaCreditCardInfo', 'limaDeviceService',
function ($rootScope, $http, $location, $urlRouter, $translate, $q, $cookies, Auth, LimaRedirect, LimaCreditCardInfo, limaDeviceService) {
  function tokenLogin(event, next) {
    event.preventDefault();
    Auth.logout();
    $cookies.put('token', $location.$$search.access_token);
    delete $location.$$search.access_token;
    Auth.updateCurrentUser().then(function (res) {
      $location.$$compose();
      $location.replace();
      $urlRouter.sync();
    }, function (err) {
      $location.$$compose();
      $location.replace();
      Auth.logout();
      LimaRedirect.go({path:'/login', returnPath:$location.path(), help:'Bad token', delay:0});
    });
  }
  function parameterLogin(event, next) {
    //event.preventDefault();
    if (Auth.isLoggedIn()) {
      //ログインに使ったParameterはログイン後、削除する
      if ($location.$$search.companyId && $location.$$search.email && $location.$$search.password) {
        delete $location.$$search.companyId;
        delete $location.$$search.email;
        delete $location.$$search.password;
        //delete $location.$$search～では消えないときがあるようなので、下記のfunctionで再度削除する
        $location.search('companyId', null);
        $location.search('email', null);
        $location.search('password', null);
      }
    }

  }
  function anonymousLogin(event, next) {
    event.preventDefault();
    $http.get('/api/v1/configurations/anonymous').success(function (anonymous) {
      if (!anonymous){
        return LimaRedirect.go({path:'/login', returnPath:$location.path(), help:'Please login', delay:0});
      }
      if (!anonymous.enabled) {
        //anonymous Login 無効だからその先進めたらいけない #10792
        return LimaRedirect.go({path:'/login', returnPath:$location.path(), help:'Please login', delay:0});
      }
      Auth.login(anonymous.user).then(function () {
        $urlRouter.sync();
      }, function () {
        var help = anonymous.enabled ? 'Anonymous login failed' : 'Please login';
        LimaRedirect.go({path:'/login', returnPath:$location.path(), help:help, delay:0});
      });
    }).error(function (err) {
      LimaRedirect.go({path:'/login', returnPath:$location.path(), help:'Failed to get anonymous login params', delay:0});
    });
  // var anonymous_user = {
  //   "email": "admin",                                                     // 匿名ログインに用いるユーザー名
  //   "password": "Mediaedge4"                                                   // 匿名ログインに用いるユーザーのパスワード
  // };
  //     Auth.login(anonymous_user).then(function () {
  //       $urlRouter.sync();
  //     });

  }

  function registerLogin(event, next) {
    //event.preventDefault();
    var anonymous = {
      "user" : {
        "email": "admin",                                                     // 匿名ログインに用いるユーザー名
        "password": "Mediaedge4"                                                   // 匿名ログインに用いるユーザーのパスワード
      }
    };
    {
      if (!anonymous)
        return LimaRedirect.go({path:'/login', returnPath:$location.path(), help:'Please login', delay:0});
      Auth.login(anonymous.user).then(function () {
        return LimaRedirect.go({path:'/register', returnPath:$location.path(), help:'', delay:0});
        //$urlRouter.sync();
      }, function () {
        var help = anonymous.enabled ? 'Anonymous login failed' : 'Please login';
        LimaRedirect.go({path:'/login', returnPath:$location.path(), help:help, delay:0});
      });
    };
  // var anonymous_user = {
  //   "email": "admin",                                                     // 匿名ログインに用いるユーザー名
  //   "password": "Mediaedge4"                                                   // 匿名ログインに用いるユーザーのパスワード
  // };
  //     Auth.login(anonymous_user).then(function () {
  //       $urlRouter.sync();
  //     });

  }


  function isCompanyExpierd( callback ){
    /* クレジットカード情報取得 */
    LimaCreditCardInfo.getCreditCardInfo(function(err, creditCardInfo, registServerUrl, companyId ) {
      if ( err ) {
        callback(false );
      }
      else {
        const info = LimaCreditCardInfo.getInfoString(creditCardInfo)
        callback(info.expired);
      }
    });
  }

  function routing(event, next, user) {
    if (next.url === '/register') {
      return registerLogin(event, next);
    }

    if (!next.authenticate) return;

    //anonymous
    if (!Auth.isLoggedIn(true))
      return anonymousLogin(event, next);


    if (!Auth.isLoggedIn()) {
      event.preventDefault();
      return LimaRedirect.go({path:'/login', returnPath:$location.path(), help:'Please login', delay:0});
    }

    isCompanyExpierd( function(expired ) {
      if (expired ) {
        LimaRedirect.go(({path:'/company/info', returnPath:$location.path()}));
      }
    });

    limaDeviceService.isOverDeviceAllowed(function(bOver){
      if (bOver) {
        LimaRedirect.go(({path:'/device', returnPath:$location.path()}));
      }
    });


    if (!next.functionName) return;


    if (!user.passwordExpired && Auth.hasFunction(next.functionName)) return;
    event.preventDefault();
    //Bug6757 ログイン中のユーザーで権限のないページに遷移させようとしたときはルートページを表示させる。パスワード期限切れの時はパスワード変更ページへ。
    var options = {path:'/', returnPath:$location.path(), help:'Forbidden', delay:0};
    if (user.passwordExpired) {
      options.path = '/settings';
      options.help = 'Password has expired';
    }
    LimaRedirect.go(options);
  }
  var onStateChangeStart = function (event, next) {
    event.preventDefault();
    $q.all([
      $translate('COMMON.OK')['catch'](angular.noop), // wait until language resource has been loaded
      Auth.systemProperties()['catch'](angular.noop) // wait until 'setting.style.id' is loaded then applied
    ]).then(function () {
      // then continue routing
      onStateChangeStart = function (event, next) {
        if ($location.$$search.access_token) {
          return tokenLogin(event, next);
        }
        parameterLogin(event, next);

        var user = Auth.getCurrentUser();
        if (user.hasOwnProperty('$promise') && user.hasOwnProperty('$resolved') && !user.$resolved) {
          event.preventDefault();
          user.$promise.then(function () { $urlRouter.sync(); }, function () { $urlRouter.sync(); });
        } else {
          routing(event, next, user);
        }
      };
      $urlRouter.sync();
    });
  };
  // Redirect to login if route requires auth and you're not logged in
  $rootScope.$on('$stateChangeStart', function (event, next) {
    onStateChangeStart(event, next);
  });
}]);
